var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiddenEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14.435L3.05669 12.3783C1.21085 11.1029 0 9.32605 0 8C0 5.68629 3.68629 2 8 2C9.5439 2 11.0074 2.4722 12.2504 3.18467L14.435 1L15.1421 1.70711L1.70709 15.1421L1 14.435ZM5.61497 9.82006L9.82005 5.61497C9.31527 5.22918 8.6844 5 8 5C6.34315 5 5 6.34315 5 8C5 8.6844 5.22918 9.31527 5.61497 9.82006Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89126 13.3722C5.85403 13.7633 6.90687 14 8 14C12.3137 14 16 10.3137 16 8C16 6.91774 15.1934 5.53517 13.8934 4.37002L10.9265 7.33695C10.9746 7.55025 11 7.77216 11 8C11 9.65686 9.65685 11 8 11C7.77216 11 7.55025 10.9746 7.33695 10.9265L4.89126 13.3722Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEyeIcon);
export default __webpack_public_path__ + "static/media/hiddenEyeIcon.cadb3cfdda9ad96e211c30c419334249.svg";
export { ForwardRef as ReactComponent };